
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "ReloadWindow",

  setup() {
    const registration = ref(null);
    const needsRefresh = ref(false);

    const showRefreshUI = (e: any) => {
      console.log(typeof e, e);
      registration.value = e.detail;
      needsRefresh.value = true;
      // My code to show the refresh UI banner/snackbar goes here.
    };

    const reload = () => {
      window.location.reload(true);
    };

    const close = () => {
      needsRefresh.value = false;
    };

    document.addEventListener("swUpdated", showRefreshUI);

    return { reload, close, needsRefresh };
  },
});
